module.exports = __webpack_public_path__ + "img/No Preview.e8a9add1.svg";